module.exports = __webpack_public_path__ + "static/media/tenge.ecf4fd90.svg";